import React, { useEffect } from "react";
import { Typography, Grid, } from "@material-ui/core";
import { getAuthNotice } from '../api/helpline/notice'
import { useGlobalState } from "../provider/Provider";
import NoticeCR from '../component/portal/notice/customer/NoticeContent'
import NoticeEE from '../component/portal/notice/employee/NoticeContent'
import { cisUser } from "../User";
import { EditorState, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'; //wysiwygエディタを整列するために必要なCSS
import '../static/css/react-draft-wysiwyg.css'; //wysiwygエディタのレイアウトを調整するカスタムCSS

interface Prop {
  handleError: (err: any) => void,
}

const rolecustomer = process.env.REACT_APP_ROLE_CUSTOMER!


const Notice: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const { handleError } = props
  const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty());
  //初期表示APIコール
  useEffect(() => {
    let cleanedup = false
    if (userId && token && role) {
      getAuthNotice(userId, token, role).then(res => {
        if (!cleanedup && (res.indexOf('{\"blocks\":[{') !== -1)) {
          setEditorState(() => EditorState.createWithContent(convertFromRaw(JSON.parse(res))));
        }
      }).catch(err => handleError(err))
    }
    return () => { cleanedup = true }
  }, [userId, token])

  return (
    <React.Fragment>
      <Typography variant="h6">お知らせ</Typography>
      <Grid container spacing={2} justify="center" >
        <Grid item xs={11}>
          {role === rolecustomer && <NoticeCR editorState={editorState} />}
          {cisUser(role) && <NoticeEE editorState={editorState} />}
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

export default Notice